




























































import { defineComponent } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseIcon from "@/components/BaseIcon";
import BaseTooltip from "@/components/BaseTooltip";
import GroupList from "@/components/GroupList";
import GroupSelectedInformer from "@/components/GroupSelectedInformer";

export default defineComponent({
  name: "MassMessageSelectView",
  components: { GroupSelectedInformer, BaseTooltip, BaseButton, BaseIcon, GroupList, BaseCheckbox },
  props: {
    loading: { type: Boolean, required: true },
    allowContinue: { type: Boolean, required: true },
    groups: { type: Array as () => Group[], required: true },
    selectedGroupIds: { type: Array as () => string[], required: true },
    excludeGroupIds: { type: Array as () => string[], required: true },
    recipientCount: { type: Number, default: 0 },
    btnIsBottom: { type: Boolean, default: false },
  },
  data() {
    return {
      helpText: $t(
        "If a user is in multiple lists and one of the lists is excluded, the user won't receive the message"
      ),
    };
  },
  methods: {
    onGroupSelect(status: boolean, groupId: string) {
      this.$emit("markGroup", status, groupId);
    },
    onExcludeGroupSelect(status: boolean, groupId: string) {
      this.$emit("markExcludedGroup", status, groupId);
    },
  },
});
